import React, { useEffect, useState } from 'react';

import { getFooterInfo } from 'apis/mainApi';

function Footer() {
  const [footerInfo, setFooterInfo] = useState({});

  const getFooter = async () => {
    await getFooterInfo()
      .then((response) => {
        if (response.data.success) {
          const obj = {};
          response.data.result.forEach(element => {
            obj[element.key] = element.value;
          });
          setFooterInfo(obj);
        }
      })
      .catch(() => {});
  };

  useEffect(() => {
    getFooter();
  }, []);

  return (
    <div id="footer">
      <div className="flex-box">
        <div className="flex-left">
          <span>CS CENTER</span>
          <a href={`tel:${footerInfo.company_phone}`} className="cscenter">
            {footerInfo.company_phone}
          </a>
          <p>MON-FRI 10:00 - 17:00 ( Lunch 12:00 - 13:00 )</p>
        </div>
        <div className="flex-right">
          <ul className="footer-info">
            <li>상호명 : {footerInfo.company_name}</li>
            <li>CEO : {footerInfo.company_owner}</li>
            <li>사업자등록번호 : {footerInfo.company_reg_no}</li>
            <li>TEL : <a href={`tel:${footerInfo.company_phone}`}>{footerInfo.company_phone}</a></li>
            <li>FAX : {footerInfo.company_fax}</li>
            <li className="custom-divider"></li>
            <li>EMAIL : <a href={`mailto:${footerInfo.company_admin_email}`}>{footerInfo.company_admin_email}</a></li>
            <li>
              주소 : {footerInfo.company_address}, {footerInfo.company_address_detail}
            </li>
          </ul>
          <p className="copyright">
            Copyright © <a href="/">Shared Designer's Lab</a>. All rights
            reserved.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Footer;
